<section class="bolt-container">
    <bolt-waiting-indicator class="bolt-space-inner-xl bolt-space-bottom-lg"
        *ngIf="docState === DocumentsStateEnum.LOADING && !isUnregisteredUser">
        Loading document information...
    </bolt-waiting-indicator>
        <bolt-notification  *ngIf="isUnregisteredUser" type="info" class="bolt-space-bottom-lg">
            <a class="bolt-link" href="{{environment.NATIONWIDE.MY_ACCOUNT_LOGIN}}" rel="noopener">Log in</a> to see this information.
        </bolt-notification>
        <div *ngIf="!(docState === DocumentsStateEnum.LOADING) && !isUnregisteredUser">
            <div class="bolt-heading-md bolt-space-bottom-lg">Documents</div>
            <bolt-notification *ngIf="docState === DocumentsStateEnum.ERROR" type="error" class="bolt-space-bottom-lg">
                Your documents didn't load. We'll get it fixed.
            </bolt-notification>
            <p class="bolt-body-copy-lg bolt-space-bottom-lg"
                *ngIf="documentsList.length === 0 && docState !== DocumentsStateEnum.ERROR">No documents are available right now. Talk to your claims
                professional if
                you have questions.</p>
            <div *ngIf="documentsList.length > 0 && docState !== DocumentsStateEnum.ERROR">
                <p class="bolt-space-bottom-md">
                    Your estimates, supporting documents and photos are right here.
                    <a class="bolt-link bolt-body-lg" href='assets/pdf/estimate.pdf' target="_blank">Learn how to read your estimate.</a>
                </p>
                <bolt-chip-group class="bolt-space-bottom-md">
                    <bolt-toggle-chip
                        *ngFor="let filter of documentFilters"
                        [label]="filter"
                        [checked]="selectedFilter === filter"
                        (change)="filterDocuments(filter)">
                    </bolt-toggle-chip>
                </bolt-chip-group>
                <div #documentDetailsMobile
                    class="mobile-only tile-stack bolt-space-bottom-md">
                    <div *ngFor="let document of paginatedDocuments"
                        class="document-card bolt-space-bottom-lg">
                        <div class="bolt-body-copy-lg ">
                            <strong>
                                <a href="javascript:void(0)"
                                   (click)="openDocument(document)"
                                   (keydown.enter)="openDocument(document)"
                                   (keydown.space)="openDocument(document); $event.preventDefault()"
                                   role="button"
                                   tabindex="0"
                                   title="Open {{ document.fileName }} in new window">
                                    {{ document.fileName }}
                                </a>
                            </strong>
                        </div>
                        <div class="bolt-body-copy-md "><strong>Uploaded by: </strong>{{ document.uploadedBy }}</div>
                        <div class="bolt-body-copy-md "><strong>Date added: </strong>{{ document.dateAdded | date: 'MM/dd/yyyy' }}</div>
                    </div>
                    <bolt-page-navigator class="pagination-alignment" id="pageNav" *ngIf="totalPages > 1"
                        [spread]="2" [current]="currentPage"
                            [total]="totalPages" (bolt-goto)="gotoPage($event)" ></bolt-page-navigator>
                </div>
                <div #documentDetailsDesktop
                    class="desktop-only bolt-table bolt-table-striped bolt-space-bottom-lg bolt-table-vibrantBlue ">
                    <table>
                        <thead>
                            <tr>
                                <th class="bolt-body-copy-lg" (click)="onSortIconClick('fileName')" (keydown.enter)="onSortIconClick('fileName')"
        (keydown.space)="onSortIconClick('fileName')"
        role="button"
        tabindex="0"
        aria-label="Sort by file name">
                                    <span class="table-heading">
                                        <span>
                                            File name
                                        </span>
                                        <span class="align-right">
                                            <bolt-icon [name]="sortOrders.fileName === 'asc' ? 'sort-up' : sortOrders.fileName === 'desc' ? 'sort-down' : 'sort-unsorted'"
                                                color="black"
                                                ></bolt-icon>
                                        </span>
                                    </span>
                                </th>
                                <th class="bolt-body-copy-lg" (click)="onSortIconClick('uploadedBy')" (keydown.enter)="onSortIconClick('uploadedBy')"
        (keydown.space)="onSortIconClick('uploadedBy')"
        role="button"
        tabindex="0"
        aria-label="Sort by uploaded by">
                                    <span class="table-heading">
                                        <span>
                                            Uploaded by
                                        </span>
                                        <span class="align-right">
                                            <bolt-icon [name]="sortOrders.uploadedBy === 'asc' ? 'sort-up' : sortOrders.uploadedBy === 'desc' ? 'sort-down' : 'sort-unsorted'"
                                                color="black"
                                                ></bolt-icon>
                                        </span>
                                    </span>
                                </th>
                                <th class="bolt-body-copy-lg" (click)="onSortIconClick('dateAdded')" (keydown.enter)="onSortIconClick('dateAdded')"
        (keydown.space)="onSortIconClick('dateAdded')"
        role="button"
        tabindex="0"
        aria-label="Sort by date added">
                                    <span class="table-heading">
                                        <span>
                                            Date added
                                        </span>
                                        <span class="align-right">
                                            <bolt-icon [name]="sortOrders.dateAdded === 'asc' ? 'sort-up' : sortOrders.dateAdded === 'desc' ? 'sort-down' : 'sort-unsorted'"
                                                color="black"
                                                ></bolt-icon>
                                        </span>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let document of paginatedDocuments">
                                <td>
                                    <a href="javascript:void(0)"
                                       (click)="openDocument(document)"
                                       (keydown.enter)="openDocument(document)"
                                       (keydown.space)="openDocument(document); $event.preventDefault()"
                                       role="button"
                                       tabindex="0"
                                       title="Open {{ document.fileName }} in new window">
                                        {{ document.fileName }}
                                    </a>
                                </td>
                                <td>{{ document.uploadedBy }}</td>
                                <td>{{ document.dateAdded | date: 'MM/dd/yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <bolt-page-navigator class="pagination-alignment" id="pageNav" *ngIf="totalPages > 1"
                        [spread]="3" [current]="currentPage"
                            [total]="totalPages" (bolt-goto)="gotoPage($event)" ></bolt-page-navigator>
                </div>
            </div>
        </div>
        <is-document-upload *ngIf="!isUnregisteredUser"
            [claimNumber]="claimNumber"
            [useCaching]="useCaching"
            (refreshRequired)="refreshDocuments()">
        </is-document-upload>
</section>
